import React, { Fragment } from 'react'
import { colors } from '../../styles'

const GuidanceIcon = () => (
  <Fragment>
    <span className="GuidanceIcon">G</span>
    <style jsx>{`
      .GuidanceIcon {
        vertical-align: middle;
        display: inline-block;
        padding: 0.25em;
        background: ${colors.red};
        color: ${colors.white};
        border-radius: 3px;
        font-weight: 700;
        font-size: 0.7em;
        border: 0.1em solid #8f070a;
        border-width: 0 0 0.1em 0;
        height: 1em;
        width: 1em;
        padding: 0.4em 0.4em 0.5em;
        margin-right: 0.5em;
        margin-right: 0.5em;
      }

      @media (min-width: 1024px) {
        .GuidanceIcon {
          font-size: 0.5em;
        }
      }
    `}
    </style>
  </Fragment>
)

export default GuidanceIcon
